// Token storage. localStorage is fine for a friends-only app; OAuth tokens are
// scoped read-only and Whoop allows revoke at any time. If you ever go public,
// move to a server.

const KEY = 'whooplens.tokens.v1'

export interface TokenSet {
  access_token: string
  refresh_token?: string
  token_type: string
  expires_at: number // epoch ms
  scope?: string
  user_id?: number
}

export function loadTokens(): TokenSet | null {
  const raw = localStorage.getItem(KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as TokenSet
  } catch {
    return null
  }
}

export function saveTokens(t: TokenSet): void {
  localStorage.setItem(KEY, JSON.stringify(t))
}

export function clearTokens(): void {
  localStorage.removeItem(KEY)
}

export function isExpired(t: TokenSet, skewSeconds = 60): boolean {
  return Date.now() >= t.expires_at - skewSeconds * 1000
}
